import { Button, ButtonGroup, Table } from "react-bootstrap";
import { handleFieldChange } from "../../Utils";

import SyncMessage from "../../components/SyncMessage";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import Form from "./components/Form";

import React from "react";
import API from "../../services/API";

import config from "./config";

import './index.css'

class AdkPartnerDomains extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            syncData: null,
            domains: [],
            form: null,
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.load_domains = this.load_domains.bind(this);
        this.handle_sync = this.handle_sync.bind(this);

        this.on_remove_submit = this.on_remove_submit.bind(this);
        this.on_create_submit = this.on_create_submit.bind(this);
        this.on_edit_submit = this.on_edit_submit.bind(this);
    }

    componentDidMount() {
        this.load_domains().catch(console.error);
    }

    async handle_sync() {
        if (!window.confirm(`Are you sure to perform sync?`)) return;

        this.setState({ loading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'partner_domains')
            .then((res) => {
                this.setState({ loading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch((err) => {
                this.setState({ loading: false, syncData: { reqErr: err } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    async load_domains() {
        this.setState({ loading: true });

        const domains = await API.AdkPartnerDomains.get();

        this.setState({ loading: false, domains });
    }

    async on_remove_submit(entity) {
        if (!window.confirm(`Are you sure to delete type: "${entity.type}", domain: "${entity.domain}"?`)) return;

        this.setState({ loading: true });

        await API.AdkPartnerDomains.remove(entity);

        await this.load_domains();
    }

    async on_create_submit(entity) {
        this.setState({ loading: true });

        await API.AdkPartnerDomains.create(entity);

        this.setState({ form: null });

        await this.load_domains();
    }

    async on_edit_submit(entity) {
        if (!window.confirm(`Type: "${entity.type}". Domain: "${this.state.form.domain}" => "${entity.domain}"`)) return;

        this.setState({ loading: true });

        delete entity.created_at;
        delete entity.updated_at;

        await API.AdkPartnerDomains.update(entity);

        this.setState({ form: null });

        await this.load_domains();
    }

    render() {
        return (
            <Container id={'adk-partner-domains'} loading={this.state.loading}>
                <Heading title="ADK Partner Domains" />

                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonGroup>
                        <Button bsStyle="primary" onClick={this.handle_sync}>Sync</Button>

                        <Button bsStyle="success" onClick={() => this.setState({ form: {} })}>Create</Button>
                    </ButtonGroup>
                </div>

                <div style={{ width: '100%', marginTop: '5px' }}>
                    <SyncMessage {...this.state.syncData} />
                </div>

                { this.state.form && <Form entity={this.state.form} on_edit={this.on_edit_submit} on_create={this.on_create_submit} on_hide={() => this.setState({ form: null })} />}

                <Table bordered responsive style={{ width: '100vw', textAlign: 'center', verticalAlign: 'middle' }}>
                    <thead>
                    <tr>
                        <th>Type</th>
                        <th>Domain</th>
                        <th>VirusTotal Configuration</th>
                        <th>VirusTotal Threshold</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Actions</th>
                    </tr>
                    </thead>

                    <tbody>
                        {this.state.domains.map((entity, index) => (
                            <tr key={entity.type}>
                                <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.type}</th>
                                <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.domain}</th>
                                <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{config.virustotal_configuration[entity.virustotal_configuration || 0]}</td>
                                <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.virustotal_threshold}</td>
                                <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.created_at}</td>
                                <td style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{entity.updated_at}</td>

                                <td style={{ width: '1%', verticalAlign: 'middle' }}>
                                    <ButtonGroup>
                                        <Button bsStyle={'primary'} onClick={() => this.setState({ form: entity })}>Edit</Button>
                                        <Button bsStyle={'danger'} onClick={() => this.on_remove_submit(entity)}>Remove</Button>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        )
    }
}

export default AdkPartnerDomains;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerDomains/index.js